import React from "react";
import { BoxArrowUpRight } from "react-bootstrap-icons";

/**
 * Represents a component for navigating to a URL with an icon.
 *
 * @param {Object} options - The options for the NavigateToUrlIcon component.
 * @param {string} options.iconSize - The size of the icon. Default value is "2rem".
 * @returns {React.Component} The rendered NavigateToUrlIcon component.
 */
const NavigateToUrlIcon = ({ iconSize = "2rem" }) => {
  return (
    <div>
      <BoxArrowUpRight size={iconSize} />
    </div>
  );
};
export default NavigateToUrlIcon;
